import React, { useContext, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function NewMeeting() {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loginInput, setLoginInput] = useState({
    title: "",
    location: "",
    memo: "",
    date: "",
  });
  const handleChange = (e) => {
    setLoginInput({
      ...loginInput,
      [e.target.name]: e.target.value,
    });
  };
  const [isLoading, setIsLoading] = useState(false);

  const { imageFunc, formDataFunc } = useApiFunction();
  const [pictures, setPictures] = useState([]);
  const { joinMemberToken } = useContext(valueContext);
  const token = joinMemberToken();

  const handleImageUpload = (e) => {
    [...e.target.files].forEach((file) => {
      setPictures([
        ...pictures,
        {
          file,
        },
      ]);
    });
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);
    if (
      !loginInput.title ||
      !loginInput.location ||
      !loginInput.date ||
      !loginInput.memo ||
      !pictures
    ) {
      toast.warning("Please fill all the details", {
        autoClose: 2000,
      });
      setIsLoading(false);
    } else {
      let body = JSON.stringify({
        title: loginInput.title,
        location: loginInput.location,
        date: loginInput.date,
        memo: loginInput.memo,
      });
      const res = await formDataFunc(
        `member/create_meeting`,
        body,
        "POST",
        token
      );

      if (res.status) {
        setIsLoading(false);
        const formDataa = new FormData();
        formDataa.append("meetingId", res.msg);
        for (let i = 0; i < pictures.length; i++) {
          formDataa.append("images", pictures[i].file);
        }
        const res1 = await imageFunc(
          `member/upload_meeting_imgs`,
          formDataa,
          "POST",
          token
        );
        if (res1.status) {
          setIsLoading(false);
          toast.success(res1.msg, { autoClose: 2000 });
          setLoginInput({ title: "", location: "", memo: "", date: "" });
        } else if (res1.error) {
          setIsLoading(false);
          toast.warning(res1.error, { autoClose: 2000 });
        } else {
          setIsLoading(false);
          toast.warning(res1.msg, { autoClose: 2000 });
        }
      } else if (res.error) {
        setIsLoading(false);
        toast.warning(res.error, { autoClose: 2000 });
      } else {
        setIsLoading(false);
        toast.warning(res.msg, { autoClose: 2000 });
      }
    }
  }

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">New Meeting</h4>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                <div className="card profile-section">
                  <div className="card-body">
                    <div className="col-lg-12 col-md-12 col-sm-6">
                      <form
                        onSubmit={(e) => {
                          handleSubmit(e);
                        }}
                      >
                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Title
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Title"
                            name="title"
                            value={loginInput.title}
                            onChange={(e) => handleChange(e)}
                            required
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            placeholder="Enter date"
                            name="date"
                            value={loginInput.date}
                            onChange={(e) => handleChange(e)}
                            required
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Memo
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Memo"
                            name="memo"
                            value={loginInput.memo}
                            onChange={(e) => handleChange(e)}
                            required
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Location
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Location"
                            name="location"
                            value={loginInput.location}
                            onChange={(e) => handleChange(e)}
                            required
                          />
                        </div>
                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Pictures ( Max 10 Pictures You Can Upload )
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            multiple
                            onChange={handleImageUpload}
                          />
                        </div>
                        {pictures.length > 0
                          ? pictures.map((data, i) => {
                              return (
                                <>
                                  <p>
                                    {data.file.name}
                                    <i
                                      className="fa fa-times"
                                      style={{ color: "red", padding: "10px" }}
                                      onClick={() => {
                                        let pic = pictures.filter(function (
                                          item
                                        ) {
                                          return pictures.indexOf(item) !== i;
                                        });
                                        setPictures(pic);
                                      }}
                                    ></i>
                                  </p>
                                </>
                              );
                            })
                          : ""}
                        <button type="submit" className="block-menu mt-4" disabled={isLoading}>
                          {isLoading && (
                            <i
                              className="bx bx-loader-circle rotating"
                              style={{ marginRight: "5px" }}
                            />
                          )}
                          Create Meeting
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default NewMeeting;
